import StarIcon from "@heroicons/react/16/solid/StarIcon";
import StarIconOutline from "@heroicons/react/24/outline/StarIcon";
import React from "react";

const RatingBar = ({reviews, starsNumber, index}) => {


    return <>
        <div key={'rating_bar_list_' + index} className={'flex items-center justify-between'}>
            <div className={'flex justify-end pr-3 items-center'}>
                <div className={'flex flex-1 items-center space-x-0.5'}>

                    {[...Array(starsNumber)].map((n, i) =>
                        <StarIcon key={'rb_review_star_col_' + index + '_' + starsNumber + '_' + i} className={'h-4 w-4 text-[#e7bb43]'}/>
                    )}
                    {[...Array(5 - starsNumber)].map((n, i) => <StarIconOutline key={'rb_main_review_star_col_' + index + '_' + starsNumber + '_' + i}
                                                                                className={'h-4 w-4 text-[#e7bb43]'}/>)}

                </div>
            </div>
            <div className={' flex flex-1 items-center justify-end'}>
                <div className={'bg-gray-300 h-1 w-full'}>
                    <div className={'bg-[#E7BB43] h-1'}
                         style={{width: parseFloat((reviews.items.filter(r => r.rating == starsNumber).length * 100) / reviews.total_count).toFixed(2) + '%'}}></div>
                </div>
                <div className={'w-1/6'}>
                    <span className={'ml-2 text-sm'}>{reviews.items.filter(r => r.rating == starsNumber).length}</span>
                </div>
            </div>
        </div>
    </>;


};

export default RatingBar;